const POSSIBLE_PLAN_SIZE_PATHS = [
  "petSizes",
  "validPetSizes",
  "validPetSize",
  "planSize",
  "subscriptionPlanSize",
  "size",
  "porte",
  "plan.size",
  "plan.sizes",
];

function getValueByPath(source, path) {
  return path.split(".").reduce((accumulator, key) => accumulator?.[key], source);
}

function toSizeList(value) {
  if (Array.isArray(value)) {
    return value
      .flatMap((item) => toSizeList(item))
      .filter(Boolean);
  }

  if (typeof value === "string") {
    return value
      .split(",")
      .map((item) => item.trim())
      .filter(Boolean);
  }

  if (value == null) return [];

  return [String(value).trim()].filter(Boolean);
}

function normalizeSize(value) {
  return String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toLowerCase();
}

function formatSizeList(sizeList = []) {
  if (!sizeList.length) return "";
  if (sizeList.length === 1) return sizeList[0];
  if (sizeList.length === 2) return `${sizeList[0]} e ${sizeList[1]}`;

  return `${sizeList.slice(0, -1).join(", ")} e ${sizeList[sizeList.length - 1]}`;
}

export function getSubscriptionPlanSizes(subscription = {}) {
  for (const path of POSSIBLE_PLAN_SIZE_PATHS) {
    const sizeList = toSizeList(getValueByPath(subscription, path));

    if (sizeList.length) return sizeList;
  }

  return [];
}

export function getSubscriptionSizeMismatchInfo(appointmentSize, subscription = {}) {
  const planSizes = ["Mini", "Pequeno", "Médio", "Grande", "Gigante"];
  // getSubscriptionPlanSizes(subscription);
  // console.log("getSubscriptionSizeMismatchInfo", { planSizes });
  const normalizedAppointmentSize = normalizeSize(appointmentSize);
  const normalizedPlanSizes = planSizes.map(normalizeSize).filter(Boolean);
  const hasApplicableSubscription = !!subscription;
  const canCompare =
    hasApplicableSubscription &&
    !!normalizedAppointmentSize &&
    normalizedPlanSizes.length > 0;
  const hasMismatch =
    canCompare && !normalizedPlanSizes.includes(normalizedAppointmentSize);
  const planSizeLabel = formatSizeList(planSizes);

  return {
    canCompare,
    hasMismatch,
    planSizes,
    planSizeLabel,
    message:
      hasMismatch
        ? `A assinatura deste pet não corresponde ao porte do banho selecionado. Por esse motivo, este atendimento não será considerado como banho de assinatura. O plano contratado para este pet é porte ${planSizeLabel}.`
        : "",
  };
}
